import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-recruiter-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './recruiter-footer.component.html',
  styleUrls: ['./recruiter-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterFooterComponent {
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
